
/**
 * Validates the users bank account name.
 */
export function validateBankAccountName(bankAccountName) {
  return bankAccountName && /^(?:([a-zA-Z\s]{1,1000}))$/.test(bankAccountName);
}
